import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FeedbackModal } from '../ui/FeedbackModal';
import { BETA_MODE } from '../../config/flags';

/**
 * Public navigation component for unauthenticated pages.
 * Displays Vester logo, tagline, and Sign up/Log in buttons.
 * Includes Feedback button for non-authenticated users.
 * 
 * In beta mode, Sign up/Log in buttons are hidden (only beta request form is accessible).
 */
const PublicNavigation: React.FC = () => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  // Don't show navigation on certain pages if needed
  // For now, show on all public pages

  return (
    <>
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Left: Logo */}
            <div className="flex items-center">
              <Link to="/" className="flex-shrink-0 flex items-center">
                <img
                  className="hidden md:block h-8 w-auto"
                  src="/Vester-logo-lrg-clr.png"
                  alt="Vester Large Logo"
                />
                <img
                  className="block md:hidden h-8 w-auto"
                  src="/Vester-logo-sm-clr.png"
                  alt="Vester Small Logo"
                />
              </Link>
            </div>

            {/* Right: Sign up, Log in, Feedback buttons */}
            <div className="flex items-center space-x-4">
              {/* Feedback button */}
              <button
                onClick={() => setIsFeedbackModalOpen(true)}
                className="relative p-2 rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500"
                title="Feedback"
              >
                <span className="sr-only">Feedback</span>
                <img
                  src="/icon-q-lrg.png"
                  alt="Feedback"
                  className="h-5 w-5"
                />
              </button>

              {/* Sign up and Log in buttons - hidden in beta mode */}
              {!BETA_MODE && (
                <>
                  {/* Sign up button */}
                  <Link
                    to="/signup"
                    className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                  >
                    Sign up
                  </Link>

                  {/* Log in button */}
                  <Link
                    to="/login"
                    className="px-4 py-2 text-sm font-medium text-green-600 bg-white border border-green-600 rounded-md hover:bg-green-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                  >
                    Log in
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Feedback Modal for non-authenticated users */}
      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={() => setIsFeedbackModalOpen(false)}
      />
    </>
  );
};

export default PublicNavigation;

